import { classNames } from '@repo/ui/src/utils/classNames';
import debounce from 'lodash/debounce';
import React from 'react';
import dynamic from 'next/dynamic';

// @ts-expect-error no type definition for react-tridi
const Tridi = dynamic(() => import('react-tridi'), { ssr: false });

interface Props {
  url: string;
  count: number;
  className?: string;
  disableMobilePointerEvents?: boolean;
  ariaLabel: string;
  children?: React.ReactNode;
}

const SpinViewer = ({
  url,
  count,
  className,
  ariaLabel,
  children,
  disableMobilePointerEvents,
}: Props) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const [loaded, setLoaded] = React.useState(false);

  const handleLoaded = React.useCallback(
    debounce(() => {
      setLoaded(true);
      ref.current?.querySelectorAll('img').forEach((img, index) => {
        if (!index) {
          img.alt = ariaLabel;
        } else {
          img.ariaHidden = 'true';
        }
      });
    }, 100),
    [],
  );

  return (
    <div className="tw-relative tw-flex tw-justify-center tw-items-center tw-h-full">
      <div
        className="tw-flex tw-justify-center lg:tw-justify-start tw-align-middle tw-flex-col tw-h-full [&_.\\_1WW7u]:tw-hidden"
        ref={ref}
      >
        <Tridi
          // @ts-expect-error - the react-tridi package does not have a types file
          location={url}
          mouseleaveDetect
          count={count}
          format="webp"
          className={classNames(
            `sm:tw-pointer-events-auto sm:tw-cursor-grab sm:active:tw-cursor-grabbing [&_img]:tw-max-h-[60vh] sm:[&_img]:tw-max-h-[80vh] tw-mt-10 lg:tw-mt-8`,
            className,
            disableMobilePointerEvents && 'tw-pointer-events-none',
            !loaded && 'tw-hidden',
          )}
          onLoadChange={handleLoaded}
        />

        {loaded && children}
      </div>
    </div>
  );
};

export default SpinViewer;
